<template>
  <page
    v-if="init"
    :flex-container="true"
    :custom-style="{
      height: '100vh'
    }"
  >
    <div class="integral-container">
      <integral-detail />
      <record />
    </div>
  </page>
</template>
<script>
import IntegralDetail from './components/IntegralDetail.vue'
import Record from './components/Record.vue'
import { navBar } from '@/utils/native_interactions/native_bar'
export default {
  name: 'IntegralIndex',
  components: {
    IntegralDetail,
    Record
  },
  beforeRouteEnter(to, from, next) {
    next(v => {
      navBar.setTitle({
        text: '积分明细'
      })
      document.title = '积分明细'
      v.$store.dispatch('integral/getScorePageInfo')
    })
  },
  data() {
    return {
      init: true
    }
  },

  methods: {
    handleGoRule() {
      this.$track(this.$trackMap.memberIntegral.INTEGRAL_DETAIL_RULE)
      const ruleUrl = this.$store.state.integral.ruleUrl
      if (ruleUrl) {
        this.$autoRedirect(ruleUrl)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.integral-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100vh;
}
</style>
